import {
	Text,
	Textarea,
	FormGroupInterface,
	Select
} from 'projects/common/src/app/types';

export function getForm(data: any, on: any, options: any = {}) {
	const STATUS = Object.freeze({
		INIT: 'init',
		DAREJECTED: 'DAREJECTED',
		DABLOCKED: 'DABLOCKED',
		DAAPPROVED: 'DAAPPROVED',
		RESUBMITTED: 'Resubmitted',
		ALL: 'All'
	});


	// if (view) {
		const form: FormGroupInterface = {
			label: '',
			submitText: !options.withoutSubmit && 'Submit Response',
			cancelText: !options.withoutCancel && 'Cancel',
			forms: [
				{
					formElements: [
						new Select(
							data.reviewCommentsLabel,
							data.reviewCommentsOptions || [
								{
									name: 'Recommended',
									value: 'recommended'
								},
								{
									name: 'Not Recommended',
									value: 'notRecommended'
								}
							],
							{
								required: true,
								name: 'review',
								onChange: on.reviewChanges
							}
						),
						new Textarea('', {
							required: true,
							name: 'comment',
							validationName: 'Comment',
							placeholder: data.commentPlaceholder || `Enter review comments here`
						})
					]
				}
			]
		};
		return form;
	}


	// }

